/* eslint-disable @typescript-eslint/no-explicit-any */
// TODO: This file was automatically migrated to TypeScript by `dev typescript migrate`.
//  The eslint disable comment above should be removed and the resulting errors fixed.
import React from 'react';

import {assert} from 'Asserts';
import ExportAuditLogButton from 'audit/ExportAuditLogButton';
import {setWindowTitle} from 'BenchlingUtil';
import DataConnector from 'connect/DataConnector';
import * as RegistryConstants from 'constants/RegistryConstants';
import {SavingState} from 'constants/RegistryConstants';
import {Printer, PrinterForCreate} from 'constants/SampleConstants';
import * as LabelPrintingActions from 'label-printing/LabelPrintingActions';
import navigateToURL from 'lib/navigateToURL';
import NavStore from 'nav/NavStore';
import * as RegistryUtil from 'registry/RegistryUtil';
import * as StorableActions from 'samples/StorableActions';
import StorableStore from 'samples/StorableStore';
import PrinterSettings from 'settings/label-printing/PrinterSettings';
import SettingsPageContainer from 'settings/SettingsPageContainer';
import {ButtonSize, ButtonStyle} from 'ui-library/buttons/Button';
import HorizontalThrobber from 'ui-library/HorizontalThrobber';

const {SAVING_STATES} = RegistryConstants;

class PrinterSettingsPageConnector extends DataConnector<PrinterSettingsPageProps, EnhancedProps> {
  navStore: any;
  props: any;
  storableStore: any;
  shouldSubscribeToRedux = false;
  stores = [NavStore, StorableStore];

  enhanceProps(): EnhancedProps {
    const registry = this.navStore().getSource(this.props.registryId);
    let newState: Omit<EnhancedProps, 'isWritable'> = {
      savingState: this.storableStore().getSavingState(),
    };
    if (this.props.printerId) {
      newState = {...newState, printer: this.storableStore().getPrinter(this.props.printerId)};
    }
    return {
      isWritable: Boolean(registry) && RegistryUtil.hasSettingsAccess(registry),
      ...newState,
    };
  }
}

export interface PrinterSettingsPageProps {
  printerId?: string;
  ownerUrlId: string;
  registryId: string;
}
interface EnhancedProps {
  isWritable: boolean;
  savingState: SavingState;
  printer?: Printer;
}

export class PrinterSettingsPage extends React.Component<PrinterSettingsPageProps & EnhancedProps> {
  componentDidMount(): void {
    this._fetchPrinters();
  }

  componentDidUpdate(prevProps: PrinterSettingsPageProps & EnhancedProps, prevState: any): void {
    if (this.props.printerId !== prevProps.printerId) {
      this._fetchPrinters();
    }
    if (
      prevProps.savingState === SAVING_STATES.PENDING &&
      RegistryUtil.isSavingFinished(this.props.savingState)
    ) {
      StorableActions.resetSavingState();
    }
  }

  _fetchPrinters = (): void => {
    LabelPrintingActions.fetchPrinters();
  };

  _handleNavigateToPrinters = (): void => {
    navigateToURL(RegistryUtil.getRegistryPrintersUrl(this.props.ownerUrlId, this.props.registryId));
  };

  _handleCreate = (printer: PrinterForCreate): void => {
    LabelPrintingActions.createPrinter(this.props.registryId, this.props.ownerUrlId, printer);
  };

  _handleUpdate = (printer: Partial<Printer>): void => {
    assert(this.props.printerId != null, 'printerId must exist for update.');
    if (this.props.printerId) {
      LabelPrintingActions.updatePrinter(this.props.printerId, printer);
    }
  };

  render(): JSX.Element {
    if (this.props.printer) {
      setWindowTitle(`${this.props.printer.name} - Printers`);
    }

    return (
      <SettingsPageContainer
        onClickTitle={this._handleNavigateToPrinters}
        subtitle={this.props.printerId && this.props.printer ? this.props.printer.name : ''}
        title="Printers"
        toolbar={
          this.props.printerId && (
            <ExportAuditLogButton
              ids={[this.props.printerId]}
              buttonSize={ButtonSize.MEDIUM}
              buttonStyle={ButtonStyle.TERTIARY_GRAY}
            />
          )
        }
      >
        {this.props.printerId && !this.props.printer ? (
          <HorizontalThrobber />
        ) : (
          <PrinterSettings
            isBeingCreated={!this.props.printerId}
            isWritable={this.props.isWritable}
            printer={this.props.printer}
            onCreate={this._handleCreate}
            onUpdate={this._handleUpdate}
            savingState={this.props.savingState}
          />
        )}
      </SettingsPageContainer>
    );
  }
}

export default PrinterSettingsPageConnector.connect(PrinterSettingsPage);
